import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { Audio, Generic, Image, PDF as PDFPreview, Video } from './components';
import { createStyleSheet, ThemeContextProvider, useStyleSheet, View } from '@gopeerproject/ui-kit';
import { SUPPORTED_FILE_TYPES } from './constants';
const { IMAGES, AUDIOS, PDF, VIDEOS } = SUPPORTED_FILE_TYPES;
const getPreviewComponent = (type) => {
    switch (true) {
        case IMAGES.includes(type):
            return Image;
        case VIDEOS.includes(type):
            return Video;
        case AUDIOS.includes(type):
            return Audio;
        case PDF.includes(type):
            return PDFPreview;
        default:
            return Generic;
    }
};
export const FilePreview = ({ file, onClose }) => {
    const styles = useStyleSheet(getStyles);
    const PreviewComponent = getPreviewComponent(file.type);
    useEffect(() => {
        const keyUpListener = (e) => {
            e.key === 'Escape' && onClose();
        };
        document.addEventListener('keyup', keyUpListener);
        return () => {
            document.removeEventListener('keyup', keyUpListener);
        };
    }, [onClose]);
    const modal = document.getElementById('modal');
    if (modal)
        return ReactDOM.createPortal(React.createElement(ThemeContextProvider, { defaultColorScheme: 'dark', forcedColorScheme: 'dark' },
            React.createElement(View, { style: styles.container },
                React.createElement(PreviewComponent, { file: file, onClose: onClose }))), modal);
    return (React.createElement(View, { style: styles.container },
        React.createElement(PreviewComponent, { file: file, onClose: onClose })));
};
const getStyles = createStyleSheet(({ color }) => ({
    container: {
        flex: 1,
        left: 0,
        top: 0,
        right: 0,
        height: '100%',
        position: 'absolute',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: color.black.p100,
        overflow: 'hidden'
    }
}));
//# sourceMappingURL=index.js.map